import { useContext } from 'react';
import { CalculatorContext, CalculatorActionsContext } from './context.js';

var useSelectionCalculator = function () {
    var context = useContext(CalculatorContext);
    if (!context) {
        throw new Error('should be used inside CalculatorProvider');
    }
    return context;
};
var useSelectionCalculatorActions = function () {
    var context = useContext(CalculatorActionsContext);
    if (!context) {
        throw new Error('should be used inside CalculatorProvider');
    }
    return context;
};

export { useSelectionCalculator, useSelectionCalculatorActions };
//# sourceMappingURL=hooks.js.map
